import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FloatingContact from '../../components/feature/FloatingContact';
import { useEffect } from 'react';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20 text-center">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray mb-4 md:mb-6">
            İletişim
          </h1>
          <p className="font-sans text-sm md:text-base text-mid-gray max-w-xl mx-auto leading-relaxed px-4">
            Mimari projeleriniz için iletişime geçin
          </p>
        </div>
      </section>

      {/* Contact Info */}
      <section className="pb-16 md:pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 mb-12 md:mb-16">
            <div className="text-center md:text-left px-4 md:px-0">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto md:mx-0 mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-mail-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                E-posta
              </h3>
              <a
                href="mailto:info@leventatalay.com.tr"
                className="text-mid-gray text-sm md:text-base hover:text-dark-gray transition-colors cursor-pointer"
              >
                info@leventatalay.com.tr
              </a>
            </div>

            <div className="text-center md:text-left px-4 md:px-0">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto md:mx-0 mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-phone-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                Telefon
              </h3>
              <a
                href="tel:+905324498500"
                className="text-mid-gray text-sm md:text-base hover:text-dark-gray transition-colors cursor-pointer"
              >
                +90 532 449 85 00
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
            <div className="text-center md:text-left px-4 md:px-0">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto md:mx-0 mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-whatsapp-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                WhatsApp
              </h3>
              <a
                href="https://wa.me/905324498500?text=Merhaba,%20leventatalay.com.tr%20web%20siteniz%20%C3%BCzerinden%20yaz%C4%B1yorum."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block border border-dark-gray text-dark-gray px-4 py-2 md:px-6 md:py-2.5 text-xs md:text-sm tracking-wide hover:bg-dark-gray hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                WhatsApp ile İletişime Geç
              </a>
            </div>

            <div className="text-center md:text-left px-4 md:px-0">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto md:mx-0 mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-linkedin-box-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                LinkedIn
              </h3>
              <a
                href="https://www.linkedin.com/in/leventatalay"
                target="_blank"
                rel="noopener noreferrer"
                className="text-mid-gray text-sm md:text-base hover:text-dark-gray transition-colors cursor-pointer"
              >
                linkedin.com/in/leventatalay
              </a>
            </div>

            <div className="text-center md:text-left px-4 md:px-0">
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto md:mx-0 mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                Adres
              </h3>
              <p className="text-mid-gray text-sm md:text-base leading-relaxed">
                Folkart Towers B, Business<br />
                Bayraklı / İZMİR
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
